module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-952a93a85aff23563266f2eed2da892e.png";